<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <nav-map-sidebar :isSidebarActive="navMapSidebar" :selectedNavigationMap="selectedNavigationMap" :buttoncaption="caption" :sidebarHeader="sbarHeader" @saveData="dataSaved" @closeSidebar="navMapSidebar = false" @showHideCard="mapLocations(selectedNavigationMap.id)"/>

    <vs-table v-show="!isDrawingComponentsShown" class="vs-con-loading__container" ref="navigationMapTable" v-model="selected" @selected="handleselector" pagination :max-items="itemsPerPage" search :data="navigationMaps">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div :buttoncaption="caption" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showSidebar">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ navigationMaps.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : navigationMaps.length }} of {{ navigationMaps.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="modifiedOn">Modified On</vs-th>
        <vs-th sort-key="modifiedBy">Modified By</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <img :src="tr.sceneThumbnailUrl" height=100% @click.stop="rowImageClicked(tr)" />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedOn.replace("T", " ").split('.')[0] }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedBy  }}</p>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div v-show="isDrawingComponentsShown" id="canvas">
      <vs-divider class="mb-6">Click on the Image to Map an Area</vs-divider>
      <img class="canvas-area input-xxlarge" :sceneUrl="sceneImageUrl">
        
      <div class="vx-row mt-2">
        <vs-input placeholder="Enter a Name" class="w-1/3 md:w-2/3 lg:w-1/3 ml-4" v-model="locationMapData.name"/>
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <div class="lg:pt-0 sm:pt-0 md:pt-4 pt-4">
            <vs-button color="success" class="mr-3 vs-con-loading__container" ref="addMapLocationButton" :disabled="isDisabled" @click="saveMappedLocation">Add</vs-button>
            <vs-button color="warning" type="border" @click="resetCanvas">Clear</vs-button>
            <vs-button class="ml-20" @click="done">Done</vs-button>
          </div>
        </div>
      </div>

      <vs-divider class="mb-6 pt-0"></vs-divider>

      <vs-table ref="mappedLocationsTable" pagination max-items="10" :data="mappedLocations">
        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="deleteMappedLocation(tr.id)"></vs-button>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    
  </div>
</template>

<script>
  import jQuery from './jquery';
  import navMapSidebar from './NavigationForm.vue';
  import canvas from './jquery.canvasAreaDraw';
  import { setTimeout } from 'timers';

  export default {
    components: {
      navMapSidebar
    },
    data() {
      return {
        backgroundLoading:'#fff',
        locationMapData: {
          id: 0,
          navigationMapId: 0,
          name: "",
          imgWidth: 0,
          imgHeight: 0,
          points: []
        },
        navigationMapId: 0,
        saved: false,
        scenes: [],
        selected: [],
        itemsPerPage: 6,
        isMounted: false,
        navigationMaps: [],
        navMapSidebar: false,
        selectedNavigationMap: {},
        caption: "",
        sbarHeader: "",
        isDrawingComponentsShown: false,
        mappedLocations: [],
        sceneImageUrl: ""
      }
    },
    computed: {
      isDisabled: function() {
        return !(this.locationMapData.name);
      },
      currentPage() {
        if(this.isMounted) {
          return this.$refs.navigationMapTable.currentx
        }
        return 0
      },
    },
    methods: {
      initCanvas() {
        $('.canvas-area[sceneUrl]').canvasAreaDraw();
      },
      handleselector(tr) {
        this.navMapSidebar = true;
        this.selectedNavigationMap = tr;
        this.sceneImageUrl = this.selectedNavigationMap.sceneImageUrl;
        this.caption = "Update";
        this.sbarHeader = "Update Navigation Map";
      },
      showSidebar() {
        this.navMapSidebar = true;
        this.selectedNavigationMap = {};
        this.caption = "Add";
        this.sbarHeader = "Add Navigation Map";
      },
      dataSaved() {
        this.navMapSidebar = false;
        this.loadData();
      },
      loadData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.navigationMaps = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.navigationMapTable.$el);
          self.$refs.navigationMapTable.searchx = "";
        };

        self.$ajaxGet(self, "NavigationMap/ListNavigationMaps", onSuccess, onFinally);
      },
      showLoadingOnTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.navigationMapTable.$el,
          scale: 1
        });
      },
      showLoadingOnAddButton(){
        var self = this;
        self.$vs.loading({
          background: self.backgroundLoading,
          type: "material",
          container: self.$refs.addMapLocationButton.$el,
          scale: 0.45
        });
      },
      mapLocations(id) {
        this.navMapSidebar = false;
        this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
        this.navigationMapId = id;
        this.loadMappedLocations(id);
        setTimeout(function(){
          $('.canvas-area[sceneUrl]').canvasAreaDraw();
        }, 500);
        this.isDrawingComponentsShown = true;
      },
      rowImageClicked(tr) {
        this.navMapSidebar = false;
        this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
        this.navigationMapId = tr.id;
        this.sceneImageUrl = tr.sceneImageUrl;
        this.loadMappedLocations(this.navigationMapId);
        setTimeout(function(){
          $('.canvas-area[sceneUrl]').canvasAreaDraw();
        }, 500);
        this.isDrawingComponentsShown = true;
      },
      done(){
        this.isDrawingComponentsShown = false;
        this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
        this.loadData();
        $('canvas').remove();
      },
      saveMappedLocation() {
        var self = this;
        if($('.canvas-area')[0].value){
          self.showLoadingOnAddButton();
          self.locationMapData.points = ($('.canvas-area')[0].value).split(",").map(Number);

          var onSuccess = response => {
            self.locationMapData.id = response.data;
            self.loadMappedLocations(self.navigationMapId);
            self.resetCanvas();
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addMapLocationButton.$el);
          };

          if(self.locationMapData.points.length > 4){
            self.locationMapData.navigationMapId = self.navigationMapId;
            self.locationMapData.imgHeight = $('canvas')[0].height;
            self.locationMapData.imgWidth = $('canvas')[0].width;

            self.$ajaxPost(self, "NavigationMap/AddUpdateNavigationMapLocations", self.locationMapData, onSuccess, onFinally);
            
          } else {
            self.$vs.loading.close(self.$refs.addMapLocationButton.$el);
            self.$vs.notify({
              time:5500,
              title: 'Not Enough Points',
              text: 'Please select more than two (2) points on the image.',
              color: 'warning',
              position: 'top-center'
            });
          }
        } else {
          self.$vs.loading.close(self.$refs.addMapLocationButton.$el);
          self.$vs.notify({
            time:5500,
            title: 'No Points Selected',
            text: 'Please select more than two (2) points on the image.',
            color: 'warning',
            position: 'top-center'
          });
        }
      },
      loadMappedLocations(id) {
        this.loadData();
        const self = this;
        var moduleId = localStorage.getItem("currentModule");
        self.showLoadingOnMappedLocationsTable();

        var onSuccess = function(response) {
          self.mappedLocations = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mappedLocationsTable.$el);
          self.$refs.mappedLocationsTables.searchx = "";
        };

        self.$ajaxGet(self, "NavigationMap/ListMapLocations" + "?navigationMapId=" + id, onSuccess, onFinally);
      },
      deleteMappedLocation(id) {
        var self = this;
        self.showLoadingOnMappedLocationsTable();
        var onSuccess = response => {
          self.loadMappedLocations(self.navigationMapId);
          self.$vs.notify({
            title: 'Information',
            color: "success",
            text: "Mapped Location Deleted",
            iconPack: 'feather',
            icon: 'icon-trash',
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mappedLocationsTable.$el);
        };
        self.$ajaxDelete(self, "NavigationMap/DeleteNavigationMapLocation/" + id, onSuccess, onFinally);
      },
      showLoadingOnMappedLocationsTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.mappedLocationsTable.$el,
          scale: 1
        });
      },
      resetCanvas() {
        $("#resetCanvas").click();
        this.locationMapData.id = 0;
        this.locationMapData.navigationMapId = 0;
        this.locationMapData.name = "";
      }
    },
    mounted() {
      this.wasSidebarOpen = this.$store.state.reduceButton;
      var self = this;
      this.loadData();
      this.isMounted = true;

      if(this.$route.path == "/digi/navigations")
        this.$store.dispatch("updateTheme", "dark");
    },
    beforeDestroy() {
      if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
    }
  }
</script>

<style lang="scss">

  #data-list-thumb-view {
    .vs-con-table

  {
    .vs-table--header

  {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    > span

  {
    display: flex;
    flex-grow: 1;
  }

  .vs-table--search {
    padding-top: 0;
    .vs-table--search-input

  {
    padding: 0.9rem 2.5rem;
    font-size: 1rem;
    &+i

  {
    left: 1rem;
  }

  &:focus + i {
    left: 1rem;
  }

  }
  }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;
    tr

  {
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
    td

  {
    padding: 10px;
    &:first-child

  {
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  &:last-child {
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  &.img-container {
    span

  {
    display: flex;
    justify-content: center;
  }

  .product-img {
    height: 110px;
  }

  }
  }

  td.td-check {
    padding: 20px !important;
  }

  }
  }

  .vs-table--thead {
    th

  {
    padding-top: 0;
    padding-bottom: 0;
    .vs-table-text

  {
    text-transform: uppercase;
    font-weight: 600;
  }

  }

  th.td-check {
    padding: 0 15px !important;
  }

  tr {
    background: none;
    box-shadow: none;
  }

  }

  .vs-table--pagination {
    justify-content: center;
  }

  }
  }
</style>
